/**
 * <strong>Purpose:</strong> <br>
 * Provides the ability to override the description of the widget. If a
 * descriptionOverride is provided, its value is what is applied to the DOM
 * instead of the description. If the descriptionOverride is "" then the description
 * is what is applied to the DOM.
 * <br><br>
 * <strong>Contract:</strong> <br>
 * This works in conjunction with the DescriptionMixin. DO mix this in after the DescriptionMixin.
 *
 * @module MW/toolstrip/mixins/property/DescriptionOverrideMixin
 *
 * @copyright Copyright 2015 The MathWorks, Inc.
 */

define([

    "dojo/_base/declare",
    "mw-form/mixins/property/DescriptionMixin"

], function(declare, DescriptionMixin){

    var DescriptionOverrideMixin = declare(null, {

        descriptionOverride: "",

        postCreate: function (){

            this.inherited(arguments);

            this.set("descriptionOverride", this.get("descriptionOverride"));
        },

        _setDescriptionOverrideAttr: function(descriptionOverride){

            if (typeof descriptionOverride !== "string") {
                throw new Error("'description' property expects a literal string!");
            }

            this._updateDescription(descriptionOverride, true);

            this._set("descriptionOverride", descriptionOverride);

        },

        _updateDescription: function(value, origin) {

            if (origin) {

                if (value === "") {
                    value = this.description;
                }

            } else if (this.descriptionOverride !== "") {
                value = this.descriptionOverride;
            }
            arguments[0] = value;

            this.inherited(arguments);
        }

    });

    DescriptionOverrideMixin._dependencies = [
        {mixin: DescriptionMixin, orderDependent: true}
    ];

    return DescriptionOverrideMixin;

});
